<template>
  <div id="dashboard-container">

    <!-- Loading Animation -->
    <loader></loader>
    <!-- Loading Animation -->

    <!-- Export Button -->
    <button class="btn btn-warning" id="download-button" @click="exportCSV('all')" v-if="stats.length > 0">
      <i class="fas fa-download"></i> Export All
    </button>
    <!-- Export Button -->

    <!-- Export Button -->
    <button class="btn btn-warning" id="export-table-button" @click="exportTable()" v-if="stats.length > 0">
      <i class="fas fa-download"></i> Export Table
    </button>
    <!-- Export Button -->

    <!-- TODO: Refresh Button -->
    <!-- <button class="btn btn-default btn-sm pull-left refresh-button" style="display: inline;"
            @click="refresh">
      <i class="fas fa-sync-alt"></i>
    </button> -->
    <!-- Refresh Button -->

    <!-- Dashboard Header -->
    <div id="dashboard-header">

          <!-- Groups Courses Cohorts Filter -->
          <div class="row">
            <div class="col-md-12">
              <group-course-cohort-filter></group-course-cohort-filter>
            </div>
          </div>
          <!-- Groups Courses Cohorts Filter -->

    </div>
    <!-- Dashboard Header -->

    <!-- Dashboard Body -->
    <div id="dashboard-body">

      <div class="dashboard-overlay"></div>

      <div class="row">
        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
          <progress-buckets title="Progress Buckets" info="Your selections here effect both charts on the right."></progress-buckets>
        </div>

        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
          <bar-chart title="Cumulative Progress Distribution" info="All participants in all Cohorts selected at the top."></bar-chart>
        </div>

        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
          <stacked-bar-chart title="Cohort-wise Progress Distribution" info="Applies to all Cohorts selected at the top and for the Course selected in this chart's dropdown. Select more Courses at the very top to make them available in the dropdown."></stacked-bar-chart>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
          <pie-chart title="Course Total Population" info="Applies to all Cohorts (selected or unselected) for each of the Courses selected at the top."></pie-chart>
        </div>

        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
          <polar-area-chart title="Course Qualifying Population" info="The ratio of the total Course population that qualifies the set %age. A value of '0.5' in the chart means 50%, etc. Applies to all Cohorts (selected or unselected) for each of the Courses selected at the top."></polar-area-chart>
        </div>

        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
          <list-group title="Leaderboard" info="Applies to all Cohorts (selected or unselected) for each of the Courses selected at the top."></list-group>
        </div>
      </div>

      <!-- Stats Table -->
      <div class="row">
        <div class="col-md-12">
          <sublime-table></sublime-table>
        </div>
      </div>
      <!-- Stats Table -->

    </div>
    <!-- Dashboard Body -->

  </div>
</template>

<script>
import BarChart from '@/components/dashboard/charts/BarChart'
import StackedBarChart from '@/components/dashboard/charts/StackedBarChart'
import PieChart from '@/components/dashboard/charts/PieChart'
import PolarAreaChart from '@/components/dashboard/charts/PolarAreaChart'
import DatePicker from '@/components/dashboard/DatePicker'
import ProgressBuckets from '@/components/dashboard/ProgressBuckets'
import SublimeTable from '@/components/dashboard/SublimeTable'
import GroupCourseCohortFilter from '@/components/dashboard/GroupCourseCohortFilter'
import ListGroup from '@/components/dashboard/ListGroup'
import Loader from '@/components/dashboard/Loader'
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import csvHelper from '@/utils/csv-helper'

// Some FontAwesome icons
import fontawesome from '@fortawesome/fontawesome'
import faSolid from '@fortawesome/fontawesome-free-solid'
import faRegular from '@fortawesome/fontawesome-free-regular'

// Add the icon to the library so we can use it in the page
fontawesome.library.add(faSolid.faInfoCircle)
fontawesome.library.add(faSolid.faExclamationTriangle)
fontawesome.library.add(faSolid.faPlus)
fontawesome.library.add(faSolid.faMinus)
fontawesome.library.add(faSolid.faEnvelope)
fontawesome.library.add(faRegular.faCopy)
fontawesome.library.add(faSolid.faCaretUp)
fontawesome.library.add(faSolid.faCaretDown)
fontawesome.library.add(faSolid.faDownload)
fontawesome.library.add(faSolid.faSort)

export default {
  name: 'dashboard',

  components: {
    'bar-chart': BarChart,
    'stacked-bar-chart': StackedBarChart,
    'pie-chart': PieChart,
    'polar-area-chart': PolarAreaChart,
    'date-picker': DatePicker,
    'progress-buckets': ProgressBuckets,
    'sublime-table': SublimeTable,
    'group-course-cohort-filter': GroupCourseCohortFilter,
    'loader': Loader,
    'list-group': ListGroup
  },

  computed: {
    authUser () {
      return this.$store.state.curr_user
    },

    stats () {
      return this.$store.getters.filteredStats
    }
  },

  beforeDestroy () {
    this.eventHub.$off('exportCSV')
  },

  mounted () {
    this.init()
    this.trackPageLoad()

    // TODO: Temporarily disabled
    // this.eventHub.$on('exportCSV', this.exportCSV)

    /* eslint-disable */
    $(() => { $('[data-toggle="tooltip"]').tooltip() })
    /* eslint-enable */
  },

  methods: {
    /**
     * Fetches and Sets the available Store data based on the AccountType
     * of the currently authenticated User.
     *
     * @returns null
     */
    init () {
      if (this.$store.getters.userIsGroupAdmin) {
        this.$store.dispatch('fetchAndSetSingleGroup', this.authUser.GroupAdminId)
      } else if (this.$store.getters.userIsAdmin) {
        this.$store.dispatch('fetchAndSetGroups')
      } else {
        throw new Error('You are not authorized to access this resource!')
      }
    },

    /**
     * Exports a specified report to CSV. If no reportName is specified
     * it exports all available reports.
     *
     * @param   {String} reportName Name of the report to export.
     * @returns {Object} CSV file(s)
     */
    exportCSV (reportName) {
      let data = {}
      let selectedGroupName = this.$store.getters.selectedGroup.GroupName

      data = this.$store.getters[this.resolveGetterName(reportName)]

      return csvHelper.export(
        data.rows,
        data.columns,
        data.columns,
        `${selectedGroupName}_${reportName}`
      )
    },

    /**
     * Exports the filtered stats in the table
     */
    exportTable () {
      this.eventHub.$emit('sublimeTableExported')
    },

    /**
     * Returns the name of a Getter based on the provided reportName.
     * This works assuming that a Getter with the returned name
     * actually exists.
     *
     * @param {String} reportName Name of the report you need.
     *
     * @returns {String} Name of the Getter that this report ties to.
     */
    resolveGetterName (reportName) {
      /* eslint-disable */
      if (!reportName || _.trim(reportName) === '' || reportName === 'undefined') {
        throw new Error(`'reportName' should be a valid String.`)
      } else if (_.lowerCase(_.trim(reportName)) === 'all') {
        return 'allDashboardExports'
      } else {
        return `${_.camelCase(reportName)}Exports`
      }
      /* eslint-enable */
    },

    /**
     * FIXME: Let's get a proper doc in here.
     * Tracks Page loads???
     *
     * @returns null
     */
    trackPageLoad () {
      let store = this.$store
      let accessToken = store.state.access_token
      let userDataForActivity = `
        UserName: ${this.authUser.UserName},
        FullName: ${this.authUser.FirstName} ${this.authUser.LastName},
        Email: ${this.authUser.Email}
      `

      let trackingObj = {
        ActivityData: 'View Dashboard , ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Manage_Dashboard,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'DASHBOARD',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    }

  }

}
</script>

<style lang="scss" scoped>
  #dashboard-container {
    padding: 2em;
  }

  button#download-button,
  button#export-table-button {
    position: fixed;
    bottom: 2em;
    z-index: 5;

    background-color: rgba(255, 104, 0, 0.90) !important;
    border: 1px solid rgba(255, 104, 0, 1.00) !important;
  }

  button#download-button:hover,
  button#download-button:focus,
  button#download-button:active,
  button#export-table-button:hover,
  button#export-table-button:focus,
  button#export-table-button:active {
    background-color: rgba(255, 104, 0, 1.00) !important;
  }

  button#download-button {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue